/**
 * Production wiring for {@link completeWageproSignIn} — shared by the login
 * screen and both two-step sign-in steps, so every credentials sign-in ends
 * through the same clear-tokens → persist-native-session → enter-app order.
 */
import { isNative } from '../../lib/platform.js';
import { persistNativeSession } from '../../lib/auth/native_shell_auth.js';
import type { NativeSessionCarrier } from '../../lib/auth/native_shell_auth.js';
import { setNativeSessionToken } from '../../lib/auth/native_session_store.js';
import { performCookieLoginPostAction } from '../../lib/auth/auth_context.js';
import { clearStoredTokens } from '../../lib/auth/token_store.js';
import {
  completeWageproSignIn,
  type CompleteSignInResult,
} from '../../lib/auth/complete_sign_in.js';

export function finishSignIn(
  result: NativeSessionCarrier,
  onSignedIn?: () => void,
): Promise<CompleteSignInResult> {
  return completeWageproSignIn(result, {
    native: isNative(),
    // `performCookieLoginPostAction` never throws — a broken storage clear
    // must not abort the sign-in.
    clearBearerTokens: () =>
      performCookieLoginPostAction({
        clearBearerTokens: () => clearStoredTokens(),
      }),
    persistNativeSession: (carrier, native) =>
      persistNativeSession(carrier, {
        native,
        setToken: (token) => setNativeSessionToken(token, { native }),
      }),
    enterApp: () => {
      onSignedIn?.();
      // On web the session cookie IS the sign-in; in the native shell it is
      // the token persisted just before this runs. Either way, no OAuth hop.
      window.location.href = '/';
    },
  });
}
